/// <reference path="constants.ts" />
/// <reference path="authenticationservice.ts" />
/// <reference path="accountservice.ts" />
module Cfnc.Security {

    export interface IRedirectService {
        redirect: (url?: string) => void;
        clear: () => void;
    }

    export interface IAuthenticationProviderUrls {
        authority: string;
        redirect_uri: string;
        post_logout_redirect_uri: string;
        silent_redirect_uri: string;
        login: string;
        postLogout: string;
        home: string;
        register: string;
    }

    export interface IAuthenticationEvents {
        login: any;
        logout: any;
        register: any;
        reloadUser: any;
        closeOAuthWindow: any;
        loginCheckCompleted: any;
    }

    export class AuthenticationProvider {
        registerThenLogin: boolean = true;
        usePopups: boolean = false;
        useFullRefreshForLoginUrl = true;
        useFullRefreshForRedirect = false;
        providerUrls: IAuthenticationProviderUrls = {
            authority: "https://localhost:44373",
            redirect_uri: "https://localhost:44302/signin-callback",
            post_logout_redirect_uri: "https://localhost:44302/signout-callback",
            silent_redirect_uri: "https://localhost:44302/silent-callback.html",
            login: "http://authlocal.cfnc.org:56311/connect/authorize?client_id=cfncweb&scope=openid&response_type=code",
            register: "https://localhost:44373/Identity/Account/Register",
            postLogout: "/login",
            home: "/"
        };
        events: IAuthenticationEvents = {
            login: "loginEvent",
            logout: "logoutEvent",
            register: null,
            reloadUser: null,
            closeOAuthWindow: null,
            loginCheckCompleted: "loginCheckCompletedEvent"
        };
        clientId: string;
        scope: string;


        $get: Array<any>;

        constructor(public apiUrls: IAccountUrls) {
            this.clientId = "CfncClientLocal";
            this.$get = ["authentication.api", "$rootScope", "$q", "$http", "$location", "$timeout", "$window", "$cookies", "$uibModal", "$routeParams", "Idle", "Title", "config", (api, $rootScope, $q, $http, $location, $timeout, $window, $cookies, $uibModal, $routeParams, Idle, Title, config: IConfig) => {
                return new AuthenticationService(api, this, $rootScope, $q, $http, $location, $timeout, $window, $cookies, $uibModal, $routeParams, Idle, Title, config);
            }];
        }
    }

    angular.module("authentication", ["ngRoute", "ngCookies", "ui.bootstrap", "ngIdle"])
        .constant("authentication.urls", {
            host: "https://localhost:44302",
            xapHost: "http://test1.cfnc.org",
            site: "/",
            manage: "/manage",
            join: "/account/register",
            login: "/token",
            logout: "/account/logout",
            xapLogout: "/CFITransitions/Security/logout.svc/LogUserOut",
            forgotPassword: "/account/forgotpassword",
            resetPassword: "/account/resetpassword",
            confirmEmail: "/account/confirmEmail",
            userInfo: "/account/userInfo",
            changePassword: "/account/changePassword",
            externalLogins: "/account/externalLogins",
            manageInfo: "/account/manageInfo",
            registerExternal: "/account/registerExternal",
            addExternalLogin: "/account/addExternalLogin",
            removeLogin: "/account/removeLogin",
            exchangeToken: "/account/gettoken"
        })
        .factory("authentication.api", ["$http", "authentication.urls", ($http, urls) => {
            return new AccountService($http, urls);
        }])
        .provider("authentication", ["authentication.urls", (urls) => {
            return new AuthenticationProvider(urls);
        }]);
}